<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close_blue">
        <a href="javascript:void(0);" @click="$emit('close')">
          <CloseBlue />
        </a>
      </div>
      <div class="popup-content">
        <div class="title">האם לשלוח בקשה לתיאום צילום תמונה חדשה?</div>
        <div class="content">נחזור לתיאום בהקדם האפשרי</div>
        <div class="popup-buttons">
          <button class="popup-btn converted" @click="$emit('close')">
            ביטול
          </button>
          <button class="popup-btn">אישור</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
export default {
  components: { CloseBlue }
};
</script>

<style scoped>
.popup {
  border-radius: 60px;
}
.popup-content {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px 0;
}

.popup-content .title {
  color: var(--blue);
  font-weight: 400;
  font-size: 36px;
  line-height: 35px;
  text-align: center;
}

.popup-content .content {
  color: var(--blue);
  font-size: 28px;
  line-height: 29px;
  text-align: center;
}

.popup-content .popup-buttons {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.popup-content .popup-buttons .popup-btn {
  font-size: 21px;
  line-height: 22px;
  text-align: center;
  padding: 14px 42px;
  background-color: var(--blue);
  color: var(--bege);
  border-radius: 50px;
  border: none;
  font-family: NextExit;
}

.popup-content .popup-buttons .popup-btn.converted {
  background-color: #fff;
  color: var(--blue);
}
</style>
